<template>
    <!-- «Вгадай суму чека»: сума кошика прихована (кошик порожній — три випадкові піци 30 см),
         кожен по черзі вписує здогадку, далі сума відкривається; хто помилився найбільше — платить -->
    <div class="bp-wp-game">
        <p class="bp-wp-turn" aria-live="polite">
            <template v-if="state == 'guess'">Вгадує <b>{{ players[current] }}</b> — інші не підглядають</template>
            <template v-else>Сума: <b>{{ total }} грн</b></template>
        </p>
        <ul class="bp-wp-items">
            <li v-for="(item, i) in items" :key="i" class="bp-wp-item">
                <img v-if="item.photo" :src="item.photo" alt="" class="bp-wp-item__img">
                <span class="bp-wp-item__name">{{ item.title }}<span class="bp-wp-item__meta">{{ item.meta }}</span></span>
                <span class="bp-wp-item__price">{{ state == 'guess' ? '??' : item.sum + ' грн' }}</span>
            </li>
        </ul>
        <p class="bp-wp-hint" v-if="fromCart">Ваш кошик без знижок і доставки</p>
        <form v-if="state == 'guess'" class="bp-wp-guess" @submit.prevent="save()">
            <label class="bp-wp-guess__field">
                <input ref="input" v-model="draft" type="text" inputmode="numeric" maxlength="6" autocomplete="off"
                       :aria-label="'Здогадка, ' + players[current]" placeholder="Ваша сума">
                <span>грн</span>
            </label>
            <button type="submit" class="bp-wp-btn bp-wp-btn--main" :disabled="!valid">Записати</button>
        </form>
        <ol class="bp-wp-board">
            <li v-for="(name, i) in players" :key="i" :class="{ 'is-now': state == 'guess' && i == current, 'is-lose': state == 'done' && i == loser }">
                <span class="bp-wp-board__name">{{ name }}</span>
                <span class="bp-wp-board__val">
                    <template v-if="guesses[i] == null">—</template>
                    <template v-else-if="state == 'guess'">записано</template>
                    <template v-else>{{ guesses[i] }} грн · {{ diff(i) ? (guesses[i] > total ? '+' : '−') + diff(i) : 'точно!' }}</template>
                </span>
            </li>
        </ol>
    </div>
</template>

<script>
export default {
    name: 'GameGuess',
    props: {
        players: { type: Array, required: true }
    },
    data() {
        const cart = (this.$store.state.cart || []).filter(item => Number(item.price) > 0 && Number(item.quanity) > 0);
        let items, fromCart = cart.length > 0;
        if (fromCart) {
            items = cart.map(item => ({
                title: item.title,
                meta: [item.size, item.quanity > 1 ? '×' + item.quanity : ''].filter(Boolean).join(' '),
                photo: item.thumbnail,
                sum: Number(item.price) * Number(item.quanity)
            }));
        } else {
            const pizzas = (this.$store.state.products || []).filter(p => p.category_id == 1 && p.is_hidden == 0 && Number(p.price_30) > 0);
            items = pizzas.slice().sort(() => Math.random() - .5).slice(0, 3).map(p => ({ title: p.title, meta: '30 см', photo: p.thumbnail, sum: Number(p.price_30) }));
        }
        return {
            items,
            fromCart,
            total: items.reduce((sum, item) => sum + item.sum, 0),
            guesses: this.players.map(() => null),
            current: 0,
            draft: '',
            state: 'guess',
            loser: null
        }
    },
    computed: {
        valid() {
            return /^\d{1,6}$/.test(this.draft.trim());
        }
    },
    mounted() {
        this.$nextTick(() => this.$refs.input && this.$refs.input.focus({ preventScroll: true }));
    },
    methods: {
        diff(i) {
            return Math.abs(this.guesses[i] - this.total);
        },
        save() {
            if (!this.valid) return;
            this.$set(this.guesses, this.current, Number(this.draft.trim()));
            this.draft = '';
            if (this.current < this.players.length - 1) {
                this.current++;
                this.$nextTick(() => this.$refs.input && this.$refs.input.focus({ preventScroll: true }));
                return;
            }
            // Найбільша похибка платить; кілька однакових — вирішує жереб
            const worst = Math.max(...this.players.map((_, i) => this.diff(i)));
            const tied = this.players.map((_, i) => i).filter(i => this.diff(i) === worst);
            this.loser = tied[Math.floor(Math.random() * tied.length)];
            this.state = 'done';
            setTimeout(() => this.$emit('done', { loser: this.loser, note: 'Помилка на ' + worst + ' грн (сума ' + this.total + ' грн)' }), 2200);
        }
    }
}
</script>
